//import { MoneyLinkException } from "@/shared/utils/custom-exception";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { UploadFileService } from"@/features/accounts/ocr/services/upload-file-service";
import { OcrAccountsAggregateService } from "@/features/accounts/ocr/services/ocraccounts-aggregate-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";


export const useOcrAccountsAggregate = () => {

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const ocrAccountsAggregateService = new OcrAccountsAggregateService();
  const uploadFileService = new UploadFileService();

  /*--------------------
    イベント関連
  --------------------*/
  
  // ファイルアップロード
  const uploadFile = async (
    accountGroupId: string,
    ocrAccountId: string,
    selectedFile: File[],
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await uploadFileService.UploadFile({
        account_group_id: accountGroupId,
        ocr_account_id: ocrAccountId,
        upload_file: selectedFile,
      });
      return res;
    } catch (error) {
        console.log("uploadFile", error);
        throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  // OCR明細取込開始
  const ocrAccountsAggregate = async (
    accountGroupId: string,
    ocrAccountId: string,
    ocrProcessId: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await ocrAccountsAggregateService.OcrAccountsAggregate({
        account_group_id: accountGroupId,
        ocr_account_id: ocrAccountId,
        ocr_process_id: ocrProcessId,
      });
      return res;
    } catch (error) {
      console.log("ocrAccountsAggregate", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    uploadFile: errorHandledAsync(uploadFile, setError),
    ocrAccountsAggregate: errorHandledAsync(ocrAccountsAggregate, setError),
  };
};
